<mat-dialog-content class="app-window" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle
  [ngClass]="{'shake': shakeIt}">

  <mat-toolbar class="app-window-toobar" cdkDragHandle>
    <button i18n-matTooltip matTooltip="Drag window" matTooltipPosition="above" mat-icon-button
      class="app-window-grab-icon">
      <mat-icon>drag_indicator</mat-icon>
    </button>
    <span>{{title}}</span>
    <span fxFlex></span>
    <app-help *ngIf="help" [topic]="help"></app-help>
    <button mat-icon-button>
      <mat-icon mat-dialog-close>close</mat-icon>
    </button>
  </mat-toolbar>

  <div class="app-window-content">
    <ng-template [cdkPortalOutlet]="componentPortal" (attached)="attached($event)"></ng-template>
  </div>

</mat-dialog-content>
